// extracted by mini-css-extract-plugin
module.exports = {"query-position-item_no-expiration-date":"ProjectStats_query-position-item_no-expiration-date__97dqx","query-position-item__name":"ProjectStats_query-position-item__name__20rRb"};